/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const getIMSConfig = environment => {
  const config = {
    client_id: 'exc_app',
    environment,
    redirect_uri: getRedirectUri(),
    scope: [
      'ab.manage',
      'additional_info.job_function',
      'additional_info.projectedProductContext',
      'additional_info.roles',
      'additional_info',
      'AdobeID',
      'adobeio_api',
      'adobeio.appregistry.read',
      'audiencemanager_api',
      'creative_cloud',
      'mps',
      'openid',
      'read_organizations',
      'read_pc.acp',
      'read_pc.dma_tartan',
      'read_pc',
      'session'
    ].join(',')
  };

  // ONLY update these if new values are enabled in IMSS for Prod
  if (environment === 'prod') {
    config.scope = [
      'ab.manage',
      'additional_info.job_function',
      'additional_info.projectedProductContext',
      'additional_info.roles',
      'additional_info',
      'AdobeID',
      'adobeio_api',
      'adobeio.appregistry.read',
      'audiencemanager_api',
      'creative_cloud',
      'mps',
      'openid',
      'read_organizations',
      'read_pc.acp',
      'read_pc.dma_tartan',
      'read_pc',
      'session'
    ].join(',');
  }
  return config;
};

export const getRedirectUri = win => {
  const href = (win || window).location.href;
  const domain = /https?:\/\/(.+\.)experience/.exec(href);
  return domain ? href.replace(domain[1], '') : href;
};
